import { SESClient } from '@aws-sdk/client-ses';
import config from '@/shared/config/config';

// Initialize AWS SES Client
const sesClient = new SESClient({
    region: config.ses?.region || config.aws.region || 'us-east-1',
    credentials: {
        accessKeyId:
            config.ses?.accessKeyId || config.aws.accessKeyId || '',
        secretAccessKey:
            config.ses?.secretAccessKey || config.aws.secretAccessKey || '',
    },
});

export { sesClient };
